<template lang="html">
	<article class="step">
		<h2>{{ $t(`${sector}.a3.title`) }}</h2>
		<p>{{ $t(`${sector}.a3.desc`) }}</p>
		<step-fuels :sector="sector" abast="a3" />
		<step-energy :sector="sector" abast="a3" />
		<step-workers :sector="sector" abast="a3" />
		<step-spectators :sector="sector" abast="a3" />
		<step-external :sector="sector" abast="a3" />
		<step-products :sector="sector" abast="a3" />
		<step-waste :sector="sector" abast="a3" />
		<step-water :sector="sector" abast="a3" />
	</article>
</template>

<script>
import StepMixin from '@/mixins/StepMixin';
import StepFuels from '../blocks/StepFuels.vue';
import StepEnergy from '../blocks/StepEnergy.vue';
import StepWorkers from '../blocks/StepWorkers.vue';
import StepSpectators from '../blocks/StepSpectators.vue';
import StepExternal from '../blocks/StepExternal.vue';
import StepProducts from '../blocks/StepProducts.vue';
import StepWaste from '../blocks/StepWaste.vue';
import StepWater from '../blocks/StepWater.vue';

export default {
	name: 'StepA3',
	mixins: [StepMixin],
	components: {
		StepFuels,
		StepEnergy,
		StepWorkers,
		StepSpectators,
		StepExternal,
		StepProducts,
		StepWaste,
		StepWater,
	},
	mounted() { this.$emit('validate', true); },
};
</script>
